module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.article) ? _c('article-detail-component', [_c('div', {
    staticClass: "anchors",
    attrs: {
      "slot": "anchors"
    },
    slot: "anchors"
  }, _vm._l((_vm.anchors), function(value, key) {
    return _c('div', [_c('a', {
      class: {
        active: _vm.$route.hash == ('#' + key) || (key == 'Tables' && !_vm.$route.hash)
      },
      attrs: {
        "href": '#' + key
      }
    }, [_vm._v(_vm._s(value))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "keywords",
    attrs: {
      "slot": "keywords"
    },
    slot: "keywords"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      Keywords:\n    ")]), _vm._v(" "), _c('div', {}, _vm._l((_vm.article.keywords), function(keyword) {
    return _c('div', {
      staticClass: "link"
    }, [_vm._v(_vm._s(keyword))])
  }))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.article.title))]), _vm._v(" "), _c('issue-authors', {
    attrs: {
      "authors": _vm.article.authors
    }
  })], 1), _vm._v(" "), _c('sidebar-article-section', {
    attrs: {
      "slot": "bar",
      "article": _vm.article
    },
    slot: "bar"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "full_text"
    },
    slot: "full_text"
  }, [_c('title-block', {
    attrs: {
      "title": "Tables",
      "id": "Tables",
      "color-theme": "primary-color"
    }
  }), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Figures",
      "id": "Figures",
      "color-theme": "primary-color"
    }
  }, _vm._l((_vm.article.files.figures), function(figure) {
    return _c('div', {
      staticClass: "fullText"
    }, [_c('section', [_c('h1', [_vm._v(_vm._s(figure.label))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": figure.url
      }
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(figure.caption)
      }
    })])])
  })), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Videos",
      "id": "Videos",
      "color-theme": "primary-color"
    }
  })], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa68bb34"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/publications/article-detail/ArticleDataPage.vue
// module id = 1467
// module chunks = 1